import React from 'react';
import PropTypes from 'prop-types';
import {calculateCompletionData, getGroupPoints} from 'helpers/game-helper';
import AreaButton from 'components/ui/area-button/area-button';
import Info from 'components/ui/info/info';
import Logo from 'components/ui/logo/logo';
import InfoBar from 'components/ui/info-bar/info-bar';
import './area-hub.scss';

const AreaHub = ({scenarioData, schoolData, group, infoTitle, infoText, routes, setPageId, scenarioId }) => {
	const groupName = group.name ? group.name : group.id;
	const groupPoints = getGroupPoints(group);
	
	let customInfoText = infoText;
	if (schoolData) {
		customInfoText = infoText.replaceAll('%school%', schoolData.name);
	}
	return (
		<div className='AreaHub'>
			<div className='AreaHub-sideWrapper'>
				<div className='AreaHub-logo'><Logo scenarioId={scenarioId}/></div>
				{schoolData && <div className="AreaHub-schoolName"><span>{schoolData.name}</span></div>}
				<div className='AreaHub-infoWindow'>
					{(infoTitle && infoText) && 
						<Info 
							title={infoTitle} 
							text={customInfoText}
							scenarioId={scenarioId}
						/>
					}
				</div>
			</div>	
			
			<div className='AreaHub-middleWrapper'>
				<div className='AreaHub-header'>
					<InfoBar points={groupPoints} iconId='trophy' scenarioId={scenarioId}/>
					<div className='AreaHub-groupName'>
						<InfoBar text={groupName} iconId='person' scenarioId={scenarioId}/>
					</div>
				</div>
				<div className={'AreaHub-areaWrapper ' + scenarioId}>
					<div className={'AreaHub-areaButtons ' + scenarioId + ' number-' + routes.length}>
						{routes.map((route, index) => {
							const taskData = scenarioData.tasksData[route.id];
							const completionData = calculateCompletionData(taskData, group.assignments);
							let showRoute = true;
							if (
								route.conditions && 
								route.conditions.length > 0 &&
								route.conditions.some((condition) => {
									if (
										condition.type === 'school-property' &&
										schoolData[condition.property] !== condition.value
									) {
										return true;
									}
									return false;
								})
							) {
								showRoute = false;
							}
							if (!showRoute) {
								return null;
							}
							return (
								<div key={index} className={'AreaHub-areaButton-' + index}>
									<AreaButton
										isComplete={completionData.completedPercentage === 100}
										areaButtonId={route.id}
										name={route.name} 
										onClick={() => {setPageId(route.pageId);}}
										scenarioId={scenarioId}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

AreaHub.propTypes = {
	scenarioData: PropTypes.object.isRequired,
	schoolData: PropTypes.object,
	infoTitle: PropTypes.string.isRequired,
	infoText: PropTypes.string.isRequired,
	routes: PropTypes.array.isRequired,
	setPageId: PropTypes.func.isRequired,
	group: PropTypes.object.isRequired,
	scenarioId: PropTypes.string.isRequired,
};

export default AreaHub;